import { render } from "./chatcomponent.vue?vue&type=template&id=243303a0&scoped=true"
import script from "./chatcomponent.vue?vue&type=script&lang=js"
export * from "./chatcomponent.vue?vue&type=script&lang=js"

import "./chatcomponent.vue?vue&type=style&index=0&id=243303a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243303a0"]])

export default __exports__